import { Product } from "../data/entities";

export const resolveCustomerProductPrice = (
    product: Pick<Product, "customer_price">,
): number => product.customer_price ?? 0;

export const withDefaultCustomerPrice = <T extends { id: string }>(
    product: T,
): T & { price: number } => ({
    ...product,
    price: 0,
});
